import React, { useContext } from 'react';

let authContext = React.createContext(undefined);

const ensureContext = (value, name) => {
  if (value === undefined) {
    throw new Error(`${name} is not registered. Call registerAuthContext before using related components.`);
  }

  return value;
};

export const registerAuthContext = context => {
  authContext = context;
};

export const useAuth = () => {
  const contextValue = useContext(authContext);
  return ensureContext(contextValue, 'Auth context');
};

export const getAuthContext = () => authContext;
